const firebaseConfig = {
    apiKey: "AIzaSyBCAxrtbA4fQCJvwPCT26AAOAkH6fA0XyQ",
    authDomain: "quick-ride-bd.firebaseapp.com",
    projectId: "quick-ride-bd",
    storageBucket: "quick-ride-bd.appspot.com",
    messagingSenderId: "697205998529",
    appId: "1:697205998529:web:7431c8b40968a513066540"
  };
export default firebaseConfig;